export const EAuthAuthType = {
  "1": "MENU",
  "2": "PAGE",
  "3": "PAGEITEM",
  "4": "TABS",
  "5": "TAB",
  "6": "TABITEM",
  "7": "MODAL",
  "8": "LINK",
  "9": "BUTTON",
  "10": "INPUT",
  "11": "LABEL"
};

export const EAuthActionType = {
  "0": "UNKNOWN",
  "1": "VIEW",
  "2": "LIST",
  "3": "ADD",
  "4": "GET",
  "5": "SET",
  "6": "DEL",
  "7": "EXE",
  "8": "XLS",
  "9": "SYS",
  "-1": "ALL"
};

export const EAuthModalMode = {
  "1": "READONLY",
  "2": "EDITABLE"
};

export const EAuthAgentRoles = {
  "1": "ADMIN",
  "2": "SETTINGS",
  "3": "ORDER_VIEW",
  "4": "FLIGHT_SALE",
  "5": "HOTEL_SALE",
  "6": "TRANSFER_SALE",
  "7": "FLIGHT_REPORTS",
  "8": "HOTEL_REPORTS",
  "9": "TRANSFER_REPORTS",
  "10": "SERVICE_CENTER",
  "11": "FINANCE"
};